import axios from 'axios'
import MIS from '../utils/mis';
import { Message } from 'element-ui';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_CN,
  timeout: 300000
})

MIS.interceptors(service, Message);

export default service
